import * as React from "react";
import Chip from "@mui/material/Chip";
import Typography from "@mui/joy/Typography";

export default function SPTag({ label, color, size }) {
  return (
    <Chip
      label={
        <Typography
          sx={{ color: color }}
          level={size === "small" ? "body-xs" : "body-sm"}
        >
          {label}
        </Typography>
      }
      variant="outlined"
      size={size}
      sx={{ borderColor: color }}
    />
  );
}
